"use strict";
function DlpCustomContent($scope, $timeout, $state) {

    const ctrl = this;

    ctrl.$onInit = function () {
        $scope.customData = "Fetching account ccls state....";
        $scope.accountId = $state.params.accountId;
        store.fetch({
            method: "GET",
            url: "/customCcls/get",
            queryParams: {
                accountId: $state.params.accountId
            },
            success: function success(data) {
                $scope.customData = data;
            },
            error: function error() {
                $scope.customData = null;
                $scope.error = "Something went wrong";
            }
        });

        $scope.customData = "Fetching ccls revision....";
        store.fetch({
            method: "GET",
            url: "/customCcls/getRevision",
            success: function success(data) {
                $scope.cclRevision = data;
            },
            error: function error() {
                $scope.cclRevision = null;
                $scope.cclRevisionError = "Something went wrong";
            }
        });

        $scope.blockedAccounts = "Fetching blocked accounts...";
        store.fetch({
            method: "GET",
            url: "/DlpBlockedAccounts",
            success: function success(data) {

                $scope.blockedAccounts = data;
            },
            error: function error() {
                $scope.blockedAccounts = null;
                $scope.blockedAccountsError = "Something went wrong";
            }
        });

    };

    $scope.publishDlpAccount = function (accountId) {
        $scope.publishState = "Publishing account ccls state...";

        store.fetch({
            method: "POST",
            url: "/customCcls/publish",
            queryParams: {
                accountId: accountId
            },
            success: function success(response) {
                if(typeof response == "boolean"){
                    $scope.publishState = response ?
                        "Successfully published" :
                        "Failed to publish";
                } else {
                    $scope.publishState = response;
                }

            },
            error: function error(e) {
                $scope.publishState = "Something Went wrong";
            }
        })
    }
}